var map = {
	"./filetype-archive.svg": 9896,
	"./filetype-document.svg": 354045,
	"./filetype-excel.svg": 72237,
	"./filetype-image.svg": 6166,
	"./filetype-media.svg": 503314,
	"./filetype-pdf.svg": 166940,
	"./filetype-spreadsheet.svg": 110367,
	"./filetype-unknown.svg": 361098,
	"./filetype-word.svg": 800793,
	"./filetype-zip.svg": 725804
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 819049;